import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONFIGURATION } from '../app.constants';
import { DealerSourceMapping, NonCDKDealer, ReturnMailer, Subscriber, ClientSubscription, Dealer } from '../models';
import { throwError } from 'rxjs';
import 'rxjs/add/operator/catch';
import * as _ from 'underscore';


declare var config: any;
@Injectable({ providedIn: 'root' })
export class DealerService {
    constructor(private http: HttpClient) { }
    private AdmtServiceUrl = CONFIGURATION.baseUrls.ADMTServiceURL;
    
    getFileLogDetails(natural_key): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/getFileLogsByNaturalkey?natural_key='+natural_key);
    }
    UpdateCustReturnMailer(body: ReturnMailer): Observable<any> {
        const URL = this.AdmtServiceUrl + 'rm/UpdateCustReturnMailer';
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        let options = {
        headers: headers
        }
        return this.http.post(URL, body, options);
    }
    getOrgIdBySrcDealerCode(srcDealerCode) {
        const url = this.AdmtServiceUrl + 'dealer/getOrgIdBySrcDealerCode?src_dealer_code='+srcDealerCode;
        return this.http.get(url);
    }
    getDealers(searchtext,oem,dataSourceId,legacySourceId,mode,sort_value,pageSize,pageNo,downloadExcelFlag): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/getDealers/?searchtext=' + searchtext+'&oem_code='+oem+'&data_source_id='+dataSourceId+'&legacy_source_id='+ legacySourceId+'&mode='+mode+'&sort_value='+sort_value+'&page_size='+pageSize+'&page_no='+pageNo+'&download_excel_flag='+downloadExcelFlag);
    }
    getSubscriptionDealers(clientSubscriptionGuid,searchtext,mode,sort_value,pageSize,pageNo,downloadExcelFlag): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'client-subscription/Getsubscribeddealers/?client_subscription_guid='+clientSubscriptionGuid+'&searchtext=' + searchtext+'&mode='+mode+'&sort_value='+sort_value+'&page_size='+pageSize+'&page_no='+pageNo+'&download_excel_flag='+downloadExcelFlag);
    }
    getDealerSources(dmId): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/getDealerSources?dmId=' + dmId);
    }
    getDealerMappings(pdId): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/getDealerMappings?pdId=' + pdId);
    }
    getDealerDetails(guid): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getDealerDetails?dlrGuid=' + guid;
        return this.http.get(url);
    }
    getOemList(): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getOemList';
        return this.http.get(url);
    }
    getStatesByCountryCode(countrycode): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getStates?cc=' + countrycode;
        return this.http.get(url);
    }
    getCountryNames(): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/GetCountryNames';
        return this.http.get(url);
    }
    getTrackingLog(dlrid): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/trackingLog?dealerId=' + dlrid;
        return this.http.get(url);
    }
    saveDealerSources(body: DealerSourceMapping): Observable<DealerSourceMapping> {
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        const url = this.AdmtServiceUrl + 'dealer/SaveDealerSource';
        return this.http.post<DealerSourceMapping>(url, body, options)
    }
    DealerSave(body: NonCDKDealer): Observable<NonCDKDealer> {
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        const url = this.AdmtServiceUrl + 'dealer/dealerSave';
        return this.http.post<NonCDKDealer>(url, body, options)
    }
    delDealerSources(dlrmpid,createdBy,comments,effDate,dealermapdelflag): Observable<NonCDKDealer> {
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        const url = this.AdmtServiceUrl + 'dealer/DeleteDealerSource?DmId=' + dlrmpid+'&createdBy='+createdBy + '&effectiveDate=' + effDate +'&comments='+ comments + '&dealermapdelflg='+ dealermapdelflag;
        return this.http.post<NonCDKDealer>(url, '', options)
    }
    GetDlrCount(naturalKey,OemCode): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/DealerCount?natKey=' + naturalKey+'&oem_code='+OemCode;
        return this.http.get(url);
    }
    GetDealerSourceCount(pdId, sourceType,dlrMapId): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/DealerSourceCount?pdId=' + pdId + '&sourceType=' + sourceType + '&dlrMapId=' + dlrMapId;
        return this.http.get(url);
    }
    dealerDelete(dlrGuid,deleteComments,username): Observable<NonCDKDealer> {
        debugger;
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        const url = this.AdmtServiceUrl + 'dealer/dealerDelete?dlrGuid=' + dlrGuid+'&deletecomments='+deleteComments+'&updatedBy='+username;
        return this.http.post<NonCDKDealer>(url, '', options)
    }
    getMasterDealers(source_id,file_type_id): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getDealersList?source_id='+source_id+'&file_type_id='+file_type_id;
        return this.http.get(url);
    }
    getClients(): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getclients';
        return this.http.get(url);
    }
    getDataSource(): Observable<any> {
        const url = this.AdmtServiceUrl + 'client-subscription/getdatasource';
        return this.http.get(url);
    }
    getSourceTypes(): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getsourcetype';
        return this.http.get(url);
    }
    getLegacyDealerSources(): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getSourceOfDealer';
        return this.http.get(url);
    }
    getFileTypes(client_id): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getfiletypes?clientId=' + client_id;
        return this.http.get(url);
    }
    getTimezone(): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/timezoneGet';
        return this.http.get(url);
    }
    SaveSubscription(body: Subscriber) {
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        const url = this.AdmtServiceUrl + 'dealer/subscriptionSave';
        return this.http.post<Subscriber>(url, body, options)
    }
    getAllSubscriptions(searchtext,client_id): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/getsubscriptions?searchtext='+searchtext+'&client_id='+client_id);
    }
    getDealerSubscriptions(selectedDt): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/getdlrsubscriptions?selected_dt='+selectedDt);
    }
    getDealercounts(selectedDt,csId,code): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/getdlrcounts?selected_dt='+selectedDt+'&csId='+csId+'&status_code='+code);
    }
    delSubscription(ClientSubscriptionId,updated_by): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/clientSubscriptionDel?client_subscription_id=' + ClientSubscriptionId+'&updated_by='+updated_by);
    }
    getSubscriptionById(ClientSubscriptionId): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/subscriptionGetById?client_subscription_guid=' + ClientSubscriptionId);
    }
    updateSubscription(body: Subscriber) {
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        const url = this.AdmtServiceUrl + 'dealer/subscriptionSave';
        return this.http.post<Subscriber>(url, body, options)
    }
    clientSubscriptionsGetByPDealerId(parentDealerId): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/clientSubscriptionsGetByPDealerId?parent_dealer_id=' + parentDealerId);
    }
    DealerClientSubscriptionsGetAll(parentDealerId): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/dealerClientSubscriptionsGetAll?parent_dealer_id=' + parentDealerId);
    }
    ClientSubscriptionSave(body: ClientSubscription) {
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        const url = this.AdmtServiceUrl + 'dealer/dealerSubscriptionSave';
        return this.http.post<ClientSubscription>(url, body, options)
    }
    dealerSubscriptionDelete(parentDealerId,clientSubscriptionId,createdBy): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/dealersubscriptiondelete?parent_dealer_id=' + parentDealerId+'&client_subscription_id='+clientSubscriptionId+'&created_by='+createdBy);
    }
    getErrorLog(parentDealerId): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'client-subscription/geterrorlog?parent_dealer_id=' + parentDealerId);
    }
    dateRangeGet(): Observable<any> {
        const url = this.AdmtServiceUrl + 'client-subscription/dateRangeGet';
        return this.http.get(url);
    }
    GetCountOfDealerBySource(parentDealerId): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getcountofdealerbysource?parent_dealer_id=' + parentDealerId;
        return this.http.get(url);
    }
   GetCountOfSubscriptionByClient(parentDealerId): Observable<any> {
        const url = this.AdmtServiceUrl + 'client-subscription/getcountofsubscriptionbyclient?parent_dealer_id=' + parentDealerId;
        return this.http.get(url);
    }
    getLogCreatedDate(parentDealerId): Observable<any> {
        const url = this.AdmtServiceUrl + 'dealer/getlogcreateddate?parent_dealer_id=' + parentDealerId;
        return this.http.get(url);
    }
    downloadSuppressedRecord(parentDealerId,FileTypeCode,ClientName,createdDt): Observable<any> {
        const url = this.AdmtServiceUrl + 'client-subscription/downloadsuppressionrecord?parent_dealer_id=' + parentDealerId+'&file_type_code='+FileTypeCode+'&client_name='+ClientName+'&created_dt='+createdDt;
        return this.http.get(url);
    }
    SuppressionList(parentDealerId): Observable<any> {
        const url = this.AdmtServiceUrl + 'client-subscription/suppressionlist?parent_dealer_id=' + parentDealerId;
        return this.http.get(url);
    }  
    deleteSubscribedDealers(clientSubscriptionGuid,dealerGuids,createdBy): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'client-subscription/DeleteSubscribedDealers/?client_subscription_guid='+clientSubscriptionGuid+'&dealer_guids='+dealerGuids+'&created_by='+createdBy);
    }
    //UploadDealerFile(body: UploadList): Observable<UploadList> {
    //    let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    //    let options = { headers: httpHeaders };
    //    const url = this.AdmtServiceUrl + 'client-subscription/uploaddealerfile';
    //    return this.http.post<UploadList>(url, body, options)
    //}
    dealerTrackingLogs(daterangefilter,parentDealerId,clientId): Observable<any> {
        return this.http.get(this.AdmtServiceUrl + 'dealer/dealertrackinglogs?datarangefilter='+daterangefilter+'&parentDealerId='+parentDealerId+'&clientId='+clientId);
    }
    public getPager(totalItems: number, currentPage: number = 1, pageSize: number) {
        // calculate total pages
        let totalPages = Math.ceil(totalItems / pageSize);
        let startPage: number, endPage: number;
        if (totalPages <= 3) {
            // less than 3 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 3 total pages so calculate start and end pages
            if (currentPage <= 2) {
                startPage = 1;
                endPage = 3;
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 3;
                endPage = totalPages;
            } else {
                startPage = currentPage - 1;
                endPage = currentPage + 1;
            }
        }

        // calculate start and end item indexes
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        let pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
    
    ///------------Response JSON------------------
    private extractData(response: Response) {

        let body = response.json();
        return body;
    }
    handleServerError(error: any | any) {
        console.log(error.error || error.json() || error);
        return throwError(error.error || error.json() || error || 'Server error');
    }
}